import styled from 'styled-components';

import MotifDropdownItem from '@ey/motif-react-wrapper/DropdownItem';

export default styled(MotifDropdownItem)`
	display: flex;
	flex-direction: column;
	align-items: stretch;
	gap: 0;
`;
